import React from "react"

import { Card, Panel, Button } from "primereact";

interface Props {
  state
  callback: any,
}

export class WelcomeComponent extends React.Component<Props> {

  constructor(props: Props) {
    super(props);


  }

  generateButtonString = () => {
    let buttonHtml = [];
    buttonHtml.push(<Button label='Start Now' key="nextBtn" className="ontario-button ontario-button--primary"
      onClick={() => this.props.callback()}>

    </Button>)
    // buttonHtml.push(<Button label='Start Now' className="ontario-button ontario-button--primary" onClick={() => this.setState({displayDialog:true})} ></Button>)
    // } else {
    //   roleList.forEach(p => {
    //   buttonHtml.push(<Button label={'Start as ' + p.split(/(?=[A-Z])/).join(' ')} style={{margin:'3px'}} className="ontario-button ontario-button--primary" onClick={()=>this.props.callback(p)}></Button>)
    // })



    return buttonHtml
  }

  render() {

    if (this.props.state.hideWelcome) return null;

    return (
      <div className="ontario-row " >

        {/* <p className="ontario-lead-statement"><strong>Form Builder</strong></p> */}

        <div className="ontario-columns " style={{ height: 'auto' }}>

          <div className="row">
            <div className="col-sm-12 col-md-12 new-applicant-container">

              <Panel header="Welcome to Form Designer, Click Start Now to design your form. ">
                You can: <ul>
                  <li>
                    Design your form application by clicking the Create New Form button. You can preview your design at any time, save drafts during the creation process, and test your application in real-time. For example, if your application ID is <b>CHC</b>, it will be live simultaneously at: 👉 <a href="https://test.services.ontario.ca/on-form/#/chc ">https://test.services.ontario.ca/on-form/#/<b>chc</b></a> 
                  </li>
                  <li>
                    Enable authentication using either Azure Entra ID or Public Secure access.
                  </li>
                  <li>
                    To deploy your application, you can either:
                    <ul>
                      <li>
                        Use Docker to host it in other environments.
                      </li>
                      <li>
                        Keep it within the CXP Azure infrastructure.
                      </li>
                    </ul>
                  </li>
                </ul>
              </Panel>
            </div>
          </div>
        </div>
        <p></p>
        <div style={{ marginTop: '380px', marginRight: '12px', display: "flex", justifyContent: 'flex-end' }}>
          {this.generateButtonString()}

        </div>
      </div>
    );
  }

}

